import { observer } from "mobx-react-lite";
import React from "react";
import { YStack } from "tamagui";
import { ActivityUI } from "../activities/ActivityUI";
import { useApi } from "../core/apis";
import { OpenInAppBox } from "../core/OpenInAppBox";
import { useStores } from "../core/stores";
import { AddCardSheet } from "../sections/AddCardSheet";
import { CreatorTodoListGuide } from "./CreatorTodoListGuide";
import { DidYouKnowBanner } from "./DidYouKnowBanner";
import { PlanQuickstartOverview } from "./PlanQuickstartOverview";

export const PlanQuickstartUI = observer((props: { uid: string }) => {
  const { sectionsApi, modulesApi } = useApi();
  const { plansStore, sectionsStore, modulesStore } = useStores();
  const plan = plansStore.byId.get(props.uid);

  const planInfoSectionUid = plan?.data.sectionIds[0];
  const planInfoSection = sectionsStore.byId.get(planInfoSectionUid ?? "");
  const planInfoModuleId = planInfoSection?.data.moduleIds[0];
  const planInfoModule = planInfoModuleId
    ? modulesStore.byId.get(planInfoModuleId)
    : undefined;

  React.useEffect(() => {
    const unsubs: (() => void)[] = [];
    if (planInfoSectionUid) {
      unsubs.push(sectionsApi.watchItem(planInfoSectionUid));
    }

    if (planInfoModuleId) {
      unsubs.push(modulesApi.watchItem(planInfoModuleId));
    }

    return () => {
      unsubs.forEach((unsub) => {
        unsub();
      });
    };
  }, [sectionsApi, planInfoModuleId, modulesApi, planInfoSectionUid]);

  if (!plan || !planInfoModule) {
    return null;
  }

  const planQuickstartSectionUid = plan.data.sectionIds[1];
  const planQuickstartSection = sectionsStore.byId.get(
    planQuickstartSectionUid ?? "",
  );

  return (
    <YStack gap="$medium">
      {plan.isCreator && <CreatorTodoListGuide plan={plan} />}

      <DidYouKnowBanner plan={plan} />

      <PlanQuickstartOverview plan={plan} />
      {planQuickstartSection && (
        <AddCardSheet
          section={planQuickstartSection}
          open={plan.showAddStepSheet}
          onOpenChange={(visible: boolean) => plan.setShowAddStepSheet(visible)}
        />
      )}

      {planInfoModule && !plan.isOnlyOneModule && (
        <ActivityUI marginTop={"$medium"} moduleUid={planInfoModule.uid} />
      )}

      <OpenInAppBox planUid={plan.uid} />
    </YStack>
  );
});
